import React, { type FC } from 'react'

import './_imgInCircle.scss'
import { useTranslation } from 'react-i18next'

import { Icons } from 'helpers/icons'
import { useUserProfile } from 'store'

const ImgInCircle: FC<{
    type: string
    id?: string
    customClass?: string
    children: React.ReactNode
    hasLoader?: boolean
    clickFn?: () => void
    hasCamera?: boolean
    cameraFn?: () => void
    isLive?: boolean
    verificationMode?: boolean
}> = ({
    type,
    id,
    customClass,
    children,
    hasLoader,
    clickFn,
    hasCamera,
    cameraFn,
    isLive,
    verificationMode = false
}) => {
    const userData = useUserProfile()
    const { t } = useTranslation()
    return (
        <div
            className={`iic iic--${type}${
                customClass ? ` ${customClass}` : ''
            }`}
            onClick={clickFn}
        >
            <div className={`iic--${type}__container`}>
                {hasLoader && (
                    <>
                        <div className='iic__loader'></div>
                        <div className='iic__loader--top'></div>
                        <div className='iic__loader--left'></div>
                    </>
                )}
                {children}
                {hasCamera && id === userData?.id ? (
                    <div 
                        className={`iic__camera${
                            verificationMode ? ' iic__camera--verification-avatar' : ''
                        }`}
                        onClick={cameraFn}>
                        <img src={Icons.camera} alt={t('changeProfilePic')} />
                    </div>
                ) : (
                    ''
                )}
                {id !== userData?.id && isLive ? (
                    <div className='iic__live'>{t('live')}</div>
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}

export default ImgInCircle
